import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SmsTemplateService {

  baseUrl = environment.baseUrl;

  sms_template_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    site_id: new FormControl('', Validators.required),
    temp_name: new FormControl('', Validators.required),
    temp_content: new FormControl('', Validators.required),
    // status: new FormControl('', Validators.required),
  });

  constructor(
    private http: HttpClient,
  ) { }

  populateForm(rowData: any){
      //this.sms_template_form.setValue(rowData);
      this.sms_template_form.setValue(_.omit(rowData, 'status', 'created_at', 'updated_at'));
    }

  get_sms_templates() {
    return this.http.get(this.baseUrl + '/get_sms_templates');
  }

  toggle_site_smstemplate_status(smstemplate_id) {
    return this.http.get(this.baseUrl + '/toggle_site_smstemplate_status/' + smstemplate_id);
  }

  insert_sms_template(formData: any)
  { 
    return this.http.post(this.baseUrl + '/create_sms_template',{
      site_id : formData.site_id, 
      temp_name : formData.temp_name,
      temp_content : formData.temp_content,
      // status : formData.status,
    });
  }

  update_sms_template(formData: any)
  { 
    return this.http.post(this.baseUrl + '/update_sms_template',{
      id : formData.id,
      site_id : formData.site_id, 
      temp_name : formData.temp_name,
      temp_content : formData.temp_content,
      // status : formData.status,
    });
  }

  // delete_sms_template_details(rowid)
  // { 
  //   return this.http.post(this.baseUrl + '/delete_sms_template',{
  //     id : rowid,
  //   });
  // }


}
